import { z } from "zod";
export const PostDepartureDataStateV1Schema = z.enum([
    "ACTIVE_PROJECT",
    "DEPARTURE_PENDING",
    "LEGAL_HOLD",
    "SCHEDULED_DELETION",
    "EXPORT_ONLY",
]);
export const PostDepartureRetentionPolicyV1Schema = z
    .object({
    schemaVersion: z.literal("post-departure-retention-policy.v1.0"),
    state: PostDepartureDataStateV1Schema,
    exportObtainable: z.literal(true),
    auditRetentionDays: z.number().int().min(0),
    clientDataDeletionDaysAfterDeparture: z.number().int().min(0).nullable(),
    summary: z.string().min(1),
})
    .strict();
export const DEFAULT_POST_DEPARTURE_RETENTION_POLICY = PostDepartureRetentionPolicyV1Schema.parse({
    schemaVersion: "post-departure-retention-policy.v1.0",
    state: "ACTIVE_PROJECT",
    exportObtainable: true,
    auditRetentionDays: 2555,
    clientDataDeletionDaysAfterDeparture: null,
    summary: "Exports and departure-kit downloads remain obtainable; hosted copies follow legal-hold or scheduled deletion — no hostage data.",
});
export function transitionPostDepartureState(policy, next) {
    return PostDepartureRetentionPolicyV1Schema.parse({
        ...policy,
        state: next,
        exportObtainable: true,
    });
}
//# sourceMappingURL=post-departure-retention-policy.js.map